import { useEffect } from "react";
import type { Route } from "./hashRoute.js";

// Browser tab titles follow ui-ux-standard rule 13: most specific segment first, site name last,
// joined by " | ".

export const SITE_NAME = "Content Generation Pipeline";
const SEPARATOR = " | ";

// Section title per route kind. A Record over the Route union, so a new route kind without a
// title is a compile error.
export const ROUTE_TITLES: Record<Route["kind"], string> = {
  login: "Sign in",
  dashboard: "Dashboard",
  projects: "Projects",
  projectDetail: "Projects",
  book: "Projects",
  itemDetail: "Projects",
  newBook: "New book",
  review: "Review",
  jobs: "Jobs",
  routes: "Routes",
  templates: "Templates",
  tokens: "Tokens",
  exports: "Exports",
};

// Record pages set their own title (the record's name once loaded). Shell leaves these alone,
// because its effect runs after the page's and would overwrite it.
const RECORD_KINDS: ReadonlySet<Route["kind"]> = new Set(["projectDetail", "book", "itemDetail"]);

/** Joins segments most-specific-first and appends the site name. Blank segments are dropped. */
export function formatPageTitle(...segments: Array<string | null | undefined>): string {
  const parts = segments
    .map((segment) => segment?.trim())
    .filter((segment): segment is string => Boolean(segment));
  return [...parts, SITE_NAME].join(SEPARATOR);
}

/** The shell's title for a route, or null when the page itself owns the title. */
export function shellTitleForRoute(route: Route): string | null {
  return RECORD_KINDS.has(route.kind) ? null : formatPageTitle(ROUTE_TITLES[route.kind]);
}

/** Sets document.title; null leaves it to a child component. */
export function useDocumentTitle(title: string | null): void {
  useEffect(() => {
    if (title !== null) document.title = title;
  }, [title]);
}
